// Deep copy doesn’t reflect changes made to the new/copied object in the original object.
export const createDeepClone = (object, transferables) => {
    let cloneObject = '';
    if(transferables) {
        cloneObject = structuredClone(object, { transfer: transferables });
    } else {
        cloneObject = structuredClone(object);
    }
    return(cloneObject);
};

export const getObjectValue = (object, key) => {
    let result = false;
  
    if(object && object.hasOwnProperty(key) && (object[key] || (typeof object[key] === "boolean" && object === false) || typeof object[key] === "number")) {
        result = object[key];
    }
    return result;
};

export const getFilePseudoUUID = (file) => {
    return `${file.name}|${file.size}${file.lastModified}`;
};

export const getNameFromFilePseudoUUID = (uuid) => {
    return uuid.split("|")[0];
};

export const getImageNameFromPresignedURL = (presignedUrl) => {
    return presignedUrl.split("://")[1].split("/")[2].split("?")[0]
};

export const getBase64 = (file) => {
    return new Promise((resolve) => {
        //let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            //console.log("Called", reader);
            baseURL = reader.result;
            //console.log(baseURL);
            resolve(baseURL);
        };
        //console.log(fileInfo);
    });
};

export const chunkArray = (array, chunkSize) => {
    return new Promise((resolve) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        resolve(chunks);
    });
};

export const camelCaseToHumanReadable = (str) => {
    let returnString = '';
    let isCamel = isCamelCase(str);
    if(isCamel) {
        returnString = `${capitalizeFirstLetter(str.slice(0, isCamel))} ${capitalizeFirstLetter(str.slice(isCamel))}`;
    } else {
        returnString = capitalizeFirstLetter(str);
    }
    return returnString;
};

export const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const isCamelCase = (str) => {
    let isCamel = hasCapitalLetter(str);
    if(isCamel) {
        let hasSpace = hasWhiteSpace(str);
        let spaceIndex = '';
        if(hasSpace) {
            spaceIndex = firstSpace(str);
        }
        isCamel = firstCapitalLetter(str, 0);
        if(typeof(spaceIndex) === "number" && spaceIndex < isCamel) {
            isCamel = false;
        }
    } else {
        isCamel = hasANumber(str);
        if(isCamel) {
            isCamel  = firstNumber(str, 0);
        }
    }
    return isCamel;
};

export const hasCapitalLetter = (str) => {
    return /[A-Z]/.test(str);
};
  
export const hasWhiteSpace = (str) => {
    return /\s/g.test(str);
};
  
export const hasANumber = (str) => {
    return /[0-9]+/.test(str);
};

export const firstCapitalLetter = (str, i) => {
    if (i === str.length) {
        return 0;
    }
    if (str[i] !== ' ' && str[i] === str[i].toUpperCase()) {
        return i;
    }
    return firstCapitalLetter(str, i+1);
};
  
export const firstSpace = (str) => {
    return(str.indexOf(' '));
};
  
export const firstNumber = (str, i) => {
    if (i === str.length) {
        return 0;
    }
    if (!isNaN(str[i])) {
        return i;
    }
    return firstNumber(str, i+1);
};

export const isBase64Image = (str) => {
    const base64Pattern = /^(?:[A-Za-z0-9+/]{4})*?(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  
    // Check if the string starts with the 'data:image/' prefix
    if (!str.startsWith('data:image/')) {
        return false;
    }
  
    // Strip the prefix and check if the remaining part is valid Base64
    const base64Data = str.split(',')[1];
    return base64Pattern.test(base64Data);
};

export const base64ToFile = (base64String, filename) => {
    return new Promise((resolve, reject) => {
        try {
            // Split the base64 string to remove metadata part (if it exists)
            const arr = base64String.split(',');
            
            // Get the mime type from the metadata (e.g., image/png)
            const mime = arr[0].match(/:(.*?);/)[1];
            
            // Decode base64 data
            const binaryString = atob(arr[1]);
            const len = binaryString.length;
            const uint8Array = new Uint8Array(len);
    
            // Wrap the for loop in a promise
            for (let i = 0; i < len; i++) {
                uint8Array[i] = binaryString.charCodeAt(i);
            }
    
            // Create a Blob object with the typed array
            const blob = new Blob([uint8Array], { type: mime });
    
            // Create a File object from Blob (name it as needed)
            const file = new File([blob], filename, { type: mime });
            
            resolve(file); // Resolve the promise with the File object
        } catch (error) {
            reject(error); // Reject if any error occurs
        }
    });
};

export const convertUrlToFile = async (url, fileName) => {
    return new Promise(async(resolve, reject) => {
        try {
            // Fetch the file data
            const response = await fetch(url);
            const blob = await response.blob();
        
            // Create a File object
            const file = new File([blob], fileName, { type: blob.type });
            resolve(file);
        } catch (error) {
            reject(error);
        }
    });
};